/**
 * Acura.ca/old (Desktop)
 *
 * Entry point to the legacy Acura.ca desktop web client
 *
 */

import getTranslations from './utils/getTranslations';
import theme from '../../themes/acura';
import { parseData as parseCmsData } from './api/cms';
import parseLayoutCmsData from './utils/parseLayoutCmsData';
import readConfigData from './utils/readConfigData';
import { renderNavs, renderFooter } from './desktop.layout';
import geo from '../../lib/geo';
import migrations from './desktop.migrations';
import { assign } from 'lodash';

const cmsData = parseCmsData(window.__pageContentData || {});
const layoutCmsData = parseLayoutCmsData(cmsData);
const config = readConfigData('acura-config');

const app = assign({}, {
  theme,
  isDesktop: true,
  isMobile: false,
  isResponsive: false,
  modelsNavList: [],
  env: process.env.NODE_ENV,
  version: process.env.VERSION,
  outerContainerId: 'hui-layout-container',
  pageWrapId: 'hui-content-container',
  menuPanelWidth: 390,
  vehiclePanelWidth: 780,
  firstPanelId: 'contentMenu',
  translations: getTranslations(config.language)
}, config, layoutCmsData);

renderNavs(app);
renderFooter(app);

migrations.init(app);
geo.init(app);



// WEBPACK FOOTER //
// ./src/apps/acuraca/desktop.js